<template>
  <div class="navi l">
    <el-menu default-active="1" class="el-menu-vertical-demo"  @select="handleSelect" theme="light">
      <el-menu-item index="1">{{menuNames['_1']}}</el-menu-item>
      <el-menu-item index="2">{{menuNames['_2']}}</el-menu-item>
      <el-menu-item index="3">{{menuNames['_3']}}</el-menu-item>
      <el-menu-item index="4">{{menuNames['_4']}}</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex';
export default {
  name: 'left',
  data () {
    return {
      language : '',

    }
  },
  mounted: function () {
     this.$nextTick(function () {
         this.handleSelect('1',['1']);
     })
  },
  computed: {
    menuNames:function(){
      return {
        '_1' : '基本信息',
        '_2' : '当前任务',
        '_3' : '已完成任务',
        '_4' : '结算信息',
      }
    }
  },

  methods: {
    handleSelect(key, keyPath) {
      var menuPath = '';
      keyPath.forEach((element) => {
        menuPath += this.menuNames['_'+element] + ' > ';
      }, this);
      // console.log(menuPath.substring(0,menuPath.length-3));
      this.setMenuPath(menuPath.substring(0,menuPath.length-3));
      this.setMenuPathKeys(keyPath);
      this.setMenuClickParam(key+ ',' + Math.random());
    },
    ...mapMutations(['setMenuPath','setMenuPathKeys','setMenuClickParam']),
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navi,.el-menu {width:180px;height:100%;text-align:left;background:#eef1f6;}
.navi .el-menu-item.is-active {background:#d3d1e5;color:#000;}


</style>



// WEBPACK FOOTER //
// src/components/Left.vue